import { useCallback } from 'react';
import { useToggle } from '@direct-frontend/stdlib';
import { downloadBlob } from '#shared/lib/file';
import { showError } from '#shared/lib/toast';
import { exportProductListExample } from '../api';

const ERROR_MESSAGE = 'Произошла ошибка при загрузке шаблона';

export const useProductListExample = () => {
    const { value: isLoading, toggleOn: open, toggleOff: close } = useToggle();

    const downloadTemplate = useCallback(async () => {
        try {
            open();

            const { blobData, filename } = await exportProductListExample();

            const hasBlobDocument = blobData && blobData instanceof Blob;

            hasBlobDocument ? downloadBlob(blobData, filename) : showError({ label: ERROR_MESSAGE });
        } catch (error) {
            showError({ label: ERROR_MESSAGE }, error);
        } finally {
            close();
        }
    }, [open, close]);

    return { isLoading, downloadTemplate };
};
